import React, { useState, useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import './CookieBanner.css';

function CookieBanner() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        const cookieConsent = localStorage.getItem('cookieConsent');
        if (!cookieConsent) {
            setShowBanner(true);
        }
    }, []);

    const acceptCookies = () => {
        localStorage.setItem('cookieConsent', 'true');
        setShowBanner(false);
    };

    const rejectCookies = () => {
        localStorage.setItem('cookieConsent', 'false');
        setShowBanner(false);
    };

    if (!showBanner) return null;

    return (
        <div className="cookie-banner">
            <Container>
                <Row className="align-items-center">
                    <Col lg={8}>
                        <div className="cookie-text">
                            <h6>🍪 Utilizziamo i Cookie</h6>
                            <p>
                                Questo sito utilizza cookie tecnici e di analytics per garantire il corretto 
                                funzionamento e migliorare l'esperienza utente. Continuando la navigazione 
                                accetti l'utilizzo dei cookie.
                            </p>
                        </div>
                    </Col>
                    <Col lg={4} className="text-lg-end">
                        <div className="cookie-buttons">
                            <Button 
                                variant="outline-light" 
                                size="sm" 
                                onClick={rejectCookies}
                                className="me-2"
                            >
                                Rifiuta
                            </Button>
                            <Button 
                                variant="primary" 
                                size="sm" 
                                onClick={acceptCookies}
                            >
                                Accetta
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default CookieBanner;